/**
 * @props label: Label above the multi select dropdown (string)
 * @props isOpen: to handle the default open state of the dropdown (boolean)
 * @props searchFieldPlaceholder: placeholder for the input
 * @props buttonContainerStyles: custom styles for the buttons container

* @props options: array of objects to render the dropdown items. Object consist of label, value and checked. 
 *          Example: [{ label: "Account payable", value: "1", checked: true }, { label: "Account payable 2", value: "2", checked: false }]
 
* @props suffixProps: Object containing icon or text. Set icon if we want to render the icon and set text if we want to render any text. 
                      suffixProps will set the icon or text at the right side of the text field. suffixProps can also have a callback function for click on icon (suffixIconCb: () => {})
                      Example: { icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET } or { text: "+91" } or { prefixIconCb: () => { } }
 * 
 * @props prefixProps: Object containing icon or text. Set icon if we want to render the icon and set text if we want to render any text. 
                      prefixProps will set the icon or text at the left side of the text field. prefixProps can also have a callback function for click on icon (prefixIconCb: () => {})
                      Example: { icon: VEC_ICON_NAME.ICON_DROPDOWN_CARET } or { text: "+91" } or { prefixIconCb: () => { } }

 */

import React from "react";
import { VEC_ICON_NAME } from "../../icons/constants";
import Button from "../../button/Button";
import MultiSelectDropdown from "../multiselectdropdown/MultiSelectDropdown";
import styles from './MultiSelectDropdownWButtons.styles'

export default function MultiSelectDropdownWButton({
    label = "",
    options = [],
    isOpen = false,
    suffixProps = { icon: VEC_ICON_NAME.SEARCH_ICON },
    prefixProps = {},
    dropdownOptionsCustomStyles = {},
    buttonProps = [],
    searchFieldValue = "",
    searchFieldPlaceholder = "",
    searchFieldChangeCb = () => { },
    buttonContainerStyles = {},
    onSelectOptionsCb = () => {}
}) {

    const Buttons = buttonProps.map(b => (
        <Button
            type={b.type}
            style={b.style}
            disabled={b.disabled}
            onClickCb={b.onClickCb}
            children={b.children}
            className={b.className}
        />
    ))

    const Container = (
        <div style={{ ...styles.buttonsContainer, ...buttonContainerStyles }}>
            {Buttons}
        </div>
    )

    return (
        <>
            <MultiSelectDropdown
                label={label}
                options={options}
                isOpen={isOpen}
                suffixProps={suffixProps}
                prefixProps={prefixProps}
                dropdownOptionsCustomStyles={dropdownOptionsCustomStyles}
                searchFieldValue={searchFieldValue}
                searchFieldPlaceholder={searchFieldPlaceholder}
                searchFieldChangeCb={searchFieldChangeCb}
                FooterComponent={Container}
                onSelectOptionsCb={onSelectOptionsCb}
            />
        </>
    );
}